import React from 'react'

const AlertIcon = ({ color = '#E35E50' }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13.5C12.2833 13.5 12.521 13.404 12.713 13.212C12.9043 13.0207 13 12.7833 13 12.5V8.475C13 8.19167 12.9043 7.95833 12.713 7.775C12.521 7.59167 12.2833 7.5 12 7.5C11.7167 7.5 11.4793 7.59567 11.288 7.787C11.096 7.979 11 8.21667 11 8.5V12.525C11 12.8083 11.096 13.0417 11.288 13.225C11.4793 13.4083 11.7167 13.5 12 13.5ZM12 17.5C12.2833 17.5 12.521 17.404 12.713 17.212C12.9043 17.0207 13 16.7833 13 16.5C13 16.2167 12.9043 15.979 12.713 15.787C12.521 15.5957 12.2833 15.5 12 15.5C11.7167 15.5 11.4793 15.5957 11.288 15.787C11.096 15.979 11 16.2167 11 16.5C11 16.7833 11.096 17.0207 11.288 17.212C11.4793 17.404 11.7167 17.5 12 17.5ZM12 22.5C10.6167 22.5 9.31667 22.2373 8.1 21.712C6.88333 21.1873 5.825 20.475 4.925 19.575C4.025 18.675 3.31267 17.6167 2.788 16.4C2.26267 15.1833 2 13.8833 2 12.5C2 11.1167 2.26267 9.81667 2.788 8.6C3.31267 7.38333 4.025 6.325 4.925 5.425C5.825 4.525 6.88333 3.81233 8.1 3.287C9.31667 2.76233 10.6167 2.5 12 2.5C13.3833 2.5 14.6833 2.76233 15.9 3.287C17.1167 3.81233 18.175 4.525 19.075 5.425C19.975 6.325 20.6873 7.38333 21.212 8.6C21.7373 9.81667 22 11.1167 22 12.5C22 13.8833 21.7373 15.1833 21.212 16.4C20.6873 17.6167 19.975 18.675 19.075 19.575C18.175 20.475 17.1167 21.1873 15.9 21.712C14.6833 22.2373 13.3833 22.5 12 22.5Z"
        fill={color}
      />
    </svg>
  )
}

export default AlertIcon

//url(#mask0_3813_20142)
